import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CatalogComponent } from './catalog.component';
import { ProductCardComponent } from './product-card/product-card.component';
import { SharedModule } from '../../shared/shared.module';
import { ProductDetailComponent } from './product-detail/product-detail.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MdbModule } from '../../core/mdb.module';
import { DragDropModule } from '@angular/cdk/drag-drop';

import { NavMenuComponent } from './nav-menu/nav-menu.component';
import { CatalogRoutingModule } from './catalog-routing.module';
import { ProductAllComponent } from './product-all/product-all.component';
import { CatalogHomeComponent } from './catalog-home/catalog-home.component';
import { ProductDesignComponent } from './product-design/product-design.component';
import { ProductDesignLibraryComponent } from './product-design/product-design-library/product-design-library.component';
import { ProductDesignToolComponent } from './product-design/product-design-tool/product-design-tool.component';
import { ProductDesignOptionsComponent } from './product-design/product-design-options/product-design-options.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { UploadArtModalComponent } from './product-design/upload-art-modal/upload-art-modal.component';
import { ViewFileUploadJobModalComponent } from './product-design/view-file-upload-job-modal/view-file-upload-job-modal.component';
import { CustomizeProductModalComponent } from './product-design/customize-product-modal/customize-product-modal.component';
import { AddToCartModalComponent } from './product-design/product-design-options/add-to-cart-modal/add-to-cart-modal.component';
import { EditDesignNameModalComponent } from './product-design/edit-design-name-modal/edit-design-name-modal.component';
import { EditPositionNotesModalComponent } from './product-design/product-design-tool/edit-position-notes-modal/edit-position-notes-modal.component';
import { ProductDesignLibraryModalComponent } from './product-design/product-design-library/product-design-library-modal/product-design-library-modal.component';


@NgModule({
  declarations: [
    CatalogComponent,
    ProductCardComponent,
    ProductDetailComponent,
    NavMenuComponent,
    ProductAllComponent,
    CatalogHomeComponent,
    ProductDesignComponent,
    ProductDesignLibraryComponent,
    ProductDesignToolComponent,
    ProductDesignOptionsComponent,
    UploadArtModalComponent,
    CustomizeProductModalComponent,
    AddToCartModalComponent,
    EditDesignNameModalComponent,
    EditPositionNotesModalComponent,
    ViewFileUploadJobModalComponent,
    ProductDesignLibraryModalComponent
  ],
  imports: [
    CommonModule,
    CatalogRoutingModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    MdbModule,
    ColorPickerModule,
    DragDropModule
  ]
})
export class CatalogModule { }
